import React from 'react';
import { CtaButton } from './CtaButton';
import { images } from '../data/content';
export function FinalCta() {
  return <section className="bg-navy px-5 py-16 text-white sm:py-20" aria-labelledby="final-title" data-id="element-107" data-mp="vghgnn67c9ny">
      <div className="mx-auto max-w-2xl text-center" data-id="element-108" data-mp="19fqn3v4lvpeq">
        <h2 id="final-title" className="text-[28px] font-black leading-tight tracking-tight sm:text-4xl" data-id="element-109" data-mp="15ddkhfl5o7m6">
          READY TO ORGANIZE YOUR AAC PLANNING RESOURCES?
        </h2>
        <p className="mt-5 text-[17px] leading-relaxed text-white/80" data-id="element-110" data-mp="1jb20oa4a2qkw">
          You don’t need to create every worksheet, checklist, or planning document from scratch. Start with a structured educational collection and adapt its resources to your professional context.
        </p>

        <img src={images.hero} alt="AAC Clinical Blueprint™ complete collection" className="mx-auto mt-8 w-full max-w-md" loading="lazy" data-id="element-111" data-mp="1o4d9uhwkbjfz" />

        <p className="mt-6 text-lg font-black tracking-wide text-teal-bright" data-id="element-112" data-mp="1x4tdpsh7wsld">AAC CLINICAL BLUEPRINT™</p>
        <p className="mt-1 text-[17px] font-semibold" data-id="element-113" data-mp="n5ukbxf37fen">6 Practical Volumes + 5 Specialized Bonuses</p>
        <p className="mt-4 text-xl font-bold" data-id="element-114" data-mp="s4fo26tjsh7u">
          Your price: <span className="text-5xl font-black text-gold" data-id="element-115" data-mp="s4xnfcbibbjz">$27</span> USD
        </p>

        <div className="mt-7" data-id="element-116" data-mp="x27d8t2t5p8c">
          <CtaButton label="Get AAC Clinical Blueprint™ now" data-id="element-117" data-mp="x64x5gx7mkta" />
        </div>
        <p className="mt-3 text-xs text-white/65 sm:text-sm" data-id="element-118" data-mp="1246i67e74u7e">
          One-time payment · [CONFIRM DELIVERY METHOD] · [CONFIRM REFUND POLICY]
        </p>
      </div>
    </section>;
}